import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators
} from "@angular/forms";
import { WebappService } from "../../../service/webapp.service";
import { AccountKit, AuthResponse } from "ng2-account-kit";
import {
  SearchCountryField,
  CountryISO
} from "ngx-intl-tel-input";
import * as firebaseui from 'firebaseui';
import * as firebase from 'firebase';
import { AngularFireAuth } from '@angular/fire/auth';

@Component({
  selector: "app-change-phone-number",
  templateUrl: "./change-phone-number.component.html",
  styleUrls: ["./change-phone-number.component.scss"]
})
export class ChangePhoneNumberComponent implements OnInit {
  profilelog: any;
  profileid: any;
  profileinfo: any;
  requestData: any;
  mobileForm: FormGroup;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom
  ];
  ui: firebaseui.auth.AuthUI;
  firebaseUiAuthConfig: firebaseui.auth.Config = {
    /* signInFlow: 'popup', */
    signInOptions: [
      {
        provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
        // Invisible reCAPTCHA with image challenge and bottom left badge.
        recaptchaParameters: {
          type: 'image',
          size: 'normal',
          badge: 'bottomleft'
        }
      },
    ],
    callbacks: {
      signInSuccessWithAuthResult: this.mobileVerifiedSucceed.bind(this),
      signInFailure: this.mobileVerifiedFailed.bind(this),
    },

  }
  constructor(
    private apiservice: WebappService,
    public toastr: ToastrService,
    private fb: FormBuilder,
    private router: Router,
    private translate: TranslateService,
    private afAuth: AngularFireAuth,
  ) {
    this.mobileForm = this.fb.group({
      phoneno: ["", Validators.required]
    });
  }

  ngOnInit() {
    this.profilelog = JSON.parse(localStorage.getItem("user"));
    this.profileid = this.profilelog.id;
    this.apiservice.profiledetails(this.profileid).subscribe(data => {
      if (data["status"] === "true") {
        this.profileinfo = data;
      } else {
        this.toastr.error(this.translate.instant(data["message"]));
        window.scrollTo(0, 0);
      }
    });
    this.ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(this.afAuth.auth);
    this.ui.start('#firebaseui-auth-container', this.firebaseUiAuthConfig);
  }

  mobileVerifiedSucceed(signInSuccessData) {
    if (!signInSuccessData.user.phoneNumber) {
      this.toastr.error(this.translate.instant("Mobile Number Verification Failed"));
      window.scrollTo(0, 0);
    } else {
      this.profilelog = JSON.parse(localStorage.getItem("user"));
      this.profileid = this.profilelog.id;
      let requestData = {
        "user_id": this.profileid,
        "phoneNumber": signInSuccessData.user.phoneNumber,
      }
      this.apiservice.changephoneno(requestData).subscribe(data => {
        if (data['status'] === 'true') {
          this.router.navigate(["/profile"]);
          this.toastr.success(this.translate.instant(data["message"]));
          window.scrollTo(0, 0);
        } else {
          this.toastr.error(this.translate.instant(data['message']));
          this.router.navigate(['/signin']);
        }
      });
    }
  }

  mobileVerifiedFailed(Error) {
    /* console.log("Verification failed" + Error); */
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

}
